export default __webpack_public_path__ + "static/media/faq-curious-individu.c0c44725.svg";